import { zodResolver } from '@hookform/resolvers/zod';
import { FormProvider, useForm } from 'react-hook-form';
import { ErrorMessage, Input } from '#components/atoms/forms/index.ts';
import type { ConfigOverride } from '#dn-types/host.ts';
import { configOverridesDefaultValues } from '#schemas/config-override/config-overrides-default-values.ts';
import { setValueAsNumberOrNull } from '#util/validation/set-value-as-number-or-null.ts';
import { schemas, type OverrideFormData } from './form-data.ts';
import { SingleConfigForm } from './parts/SingleConfigForm.tsx';

const OVERRIDE_KEY = 'lighthouse.interval';
const DEFAULT_VALUES = { lighthouse: { interval: configOverridesDefaultValues.lighthouse.interval } };
const schema = schemas[OVERRIDE_KEY];
type FormData = OverrideFormData[typeof OVERRIDE_KEY];

type Props = {
  defaultValues?: FormData;
  onSave: (overrides: ConfigOverride[]) => void;
};

export function LighthouseInterval({ defaultValues, onSave }: Props) {
  const formContext = useForm({
    resolver: zodResolver(schema),
    defaultValues: defaultValues ?? DEFAULT_VALUES,
  });

  const error = formContext.formState.errors.lighthouse?.interval;

  return (
    <FormProvider {...formContext}>
      <SingleConfigForm overrideKey={OVERRIDE_KEY} onSave={onSave}>
        <Input
          {...formContext.register(OVERRIDE_KEY, { setValueAs: setValueAsNumberOrNull })}
          className="width-100"
          type="number"
          placeholder="60"
          hasError={Boolean(error)}
        />
        {error && <ErrorMessage>{error.message?.toString()}</ErrorMessage>}
      </SingleConfigForm>
    </FormProvider>
  );
}
